import React from 'react';
import { getPageTypeLabel } from '../Sunburst/utilsSunburst';
import { getFormattedNumber, getFormattedPercent } from '../../../../Util/numberFormats';

const tooltipStyles: React.CSSProperties = {
	backgroundColor: 'var(--white)',
	boxShadow: 'rgba(0, 0, 0, .3) 0 1px 10px, rgba(0, 0, 0, .06) 0 2px 16px 1px, rgba(0, 0, 0, .06) 0 0 0 1px',
	//color: 'white',
	padding: '12px',
	borderRadius: '4px',
	fontSize: '13px',
	lineHeight: '1.5',
	width: '260px',
	position: 'fixed',
	top: 0,
	left: 0
};

const Tooltip = ({
	tooltipLeft,
	tooltipTop,
	tooltipData,
	TooltipWithBounds,
	isSiteExit,
	totalLevel1Sessions,
	parentNode
}) => {

	const label = getPageTypeLabel(tooltipData.name);
	const safeSessionCount = typeof tooltipData.sessionCount === 'number' && !isNaN(tooltipData.sessionCount) ? tooltipData.sessionCount : 0;
	const safeConvertedSessionCount = typeof tooltipData.convertedSessionCount === 'number' && !isNaN(tooltipData.convertedSessionCount) ? tooltipData.convertedSessionCount : 0;
	
	let safeSessionCountProportionByParent;
	if (isSiteExit) {
		const exitValue = typeof tooltipData.value === 'number' && !isNaN(tooltipData.value) ? tooltipData.value : 0;
		const parentSessionCount = parentNode && typeof parentNode.sessionCount === 'number'
			? parentNode.sessionCount
			: parentNode && typeof parentNode.value === 'number'
				? parentNode.value
				: 0;
		safeSessionCountProportionByParent = parentSessionCount ? (exitValue / parentSessionCount) * 100 : 0;
	} else {
		safeSessionCountProportionByParent = typeof tooltipData.sessionCountProportionByParent === 'number' && !isNaN(tooltipData.sessionCountProportionByParent) ? tooltipData.sessionCountProportionByParent : 0;
	}

	const valueForCalculation = isSiteExit ? (typeof tooltipData.value === 'number' && !isNaN(tooltipData.value) ? tooltipData.value : 0) : safeSessionCount;
	const percentOfTotal = totalLevel1Sessions > 0 ? ((valueForCalculation / totalLevel1Sessions) * 100) : 0;

	if (isSiteExit) {
		return (
			<TooltipWithBounds left={tooltipLeft} top={tooltipTop} style={tooltipStyles}>
				<div>
					<strong>{label}</strong> <br />
				</div>
				<div>
					<strong>Exits:</strong> {getFormattedNumber(tooltipData.value)} <br />
				</div>
				<div>
					<strong>Proportion of parent : </strong> {getFormattedPercent(safeSessionCountProportionByParent)}
				</div>
				<div>
					<strong>Proportion of sessions : </strong> {getFormattedPercent(percentOfTotal)}
				</div>
			</TooltipWithBounds>
		);
	}

	return (
		<TooltipWithBounds left={tooltipLeft} top={tooltipTop} style={tooltipStyles}>
			<div>
				<strong>Page type:</strong> {label}
			</div>
			<div>
				<strong>Session:</strong> {getFormattedNumber(tooltipData.value)}
			</div>
			<div>
				<strong>Turnover:</strong> {getFormattedNumber(tooltipData.turnover, 2, '€')}
			</div>
			<div>
				<strong>Converted session count:</strong> {getFormattedNumber(safeConvertedSessionCount)}
				<>{' '}({getFormattedPercent(safeSessionCount ? (safeConvertedSessionCount / safeSessionCount * 100) : 0)})</>
			</div>
			{tooltipData.level !== 1 && (
				<div>
					<strong>Exit rate:</strong> {getFormattedNumber(tooltipData.abandonedSessionCount)}
					{tooltipData.abandonedRate &&
						<>{' '}({getFormattedPercent(tooltipData.abandonedRate)})</>
					}
				</div>
			)}
			{tooltipData.level !== 1 && (
				<div>
					<strong>Proportion of parent sessions:</strong> {getFormattedPercent(safeSessionCountProportionByParent)}
				</div>
			)}
			<div>
				<strong>Proportion of total sessions:</strong> {getFormattedPercent(percentOfTotal)}
			</div>
		</TooltipWithBounds>
	);
};

export default Tooltip;